import { Download, Copy, Check } from 'lucide-react';
import { useState } from 'react';
import './ShareModal.css';

interface ShareModalProps {
    onClose: () => void;
}

// Social media platforms with proper Brand SVGs
const SOCIAL_PLATFORMS = [
    { 
        id: 'facebook', 
        label: 'Facebook', 
        color: '#1877F2',
        path: "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" 
    },
    { 
        id: 'twitter', 
        label: 'Twitter', 
        color: '#1DA1F2',
        path: "M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z" 
    },
    { 
        id: 'pinterest', 
        label: 'Pinterest', 
        color: '#E60023',
        path: "M8 0C5.829 0 5.556 1.49 5.556 1.49C4.305 3.226 5.584 5.253 6.944 6.944C7.778 8.056 9.444 8.056 9.444 8.056C9.444 8.056 14.444 4.056 14.444 2.5C14.444 0.944 12.235 0 8 0ZM13 14C13 14 11.5 16 9.5 16C7.5 16 6 14 6 12C6 10 7.5 8 9.5 8C11.5 8 13 10 13 14Z" // Placeholder for complex P, switching to standard path below in actual render or better simpler path
    },
    { 
        id: 'linkedin', 
        label: 'LinkedIn', 
        color: '#0A66C2',
        path: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z M2 9h4v12H2z M4 2a2 2 0 1 1-1.998 2.002A2 2 0 0 1 4 2z"
    },
    { 
        id: 'whatsapp', 
        label: 'WhatsApp', 
        color: '#25D366',
        path: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"
    },
    { 
        id: 'email', 
        label: 'Email', 
        color: '#EA4335',
        path: "M24 5.457v13.909c0 .904-.732 1.636-1.636 1.636h-3.819V11.73L12 16.64l-6.545-4.91v9.273H1.636A1.636 1.636 0 0 1 0 19.366V5.457c0-2.023 2.309-3.178 3.927-1.964L5.455 4.64 12 9.548l6.545-4.91 1.528-1.145C21.69 2.28 24 3.434 24 5.457z" 
    },
];

// Correct Pinterest Path
SOCIAL_PLATFORMS[2].path = "M8 0C5.829 0 5.556 1.49 5.556 1.49C4.305 3.226 5.584 5.253 6.944 6.944C7.778 8.056 9.444 8.056 9.444 8.056C9.444 8.056 14.444 4.056 14.444 2.5C14.444 0.944 12.235 0 8 0ZM13 14C13 14 11.5 16 9.5 16C7.5 16 6 14 6 12C6 10 7.5 8 9.5 8C11.5 8 13 10 13 14Z"; 
// Wait, the above pin path is weird. Using a standard "P" path or generic pin.
// Let's use a standard FontAwesome Pinterest path equivalent
SOCIAL_PLATFORMS[2].path = "M12 0a12 12 0 0 0-4.37 23.17c-.07-.63-.13-1.6.03-2.29l.73-3.11s-.19-.38-.19-.94c0-.88.51-1.54 1.15-1.54.54 0 .8.41.8.9 0 .55-.35 1.37-.53 2.13-.15.64.32 1.16.95 1.16 1.14 0 2.02-1.2 2.02-2.93 0-1.53-1.1-2.6-2.67-2.6-1.95 0-3.09 1.46-3.09 2.97 0 .59.23 1.22.51 1.56.06.07.07.14.05.21l-.19.8c-.03.11-.09.13-.2.08-1.13-.53-1.84-2.17-1.84-3.5 0-2.85 2.07-5.47 5.97-5.47 3.13 0 5.56 2.23 5.56 5.21 0 3.11-1.96 5.62-4.68 5.62-.91 0-1.77-.48-2.07-1.04l-.56 2.14c-.2.78-.75 1.76-1.12 2.36a11.96 11.96 0 0 0 18.06-8.86C24 5.37 18.63 0 12 0z";


export default function ShareModal({ onClose }: ShareModalProps) {
    const [copied, setCopied] = useState(false);
    const [copiedImage, setCopiedImage] = useState(false);

    // Copy link to clipboard
    const handleCopyLink = () => {
        navigator.clipboard.writeText(window.location.href);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    // Copy image to clipboard
    const handleCopyImage = async () => {
        try {
            const canvas = document.querySelector('canvas');
            if (!canvas) return;
            
            // Create a temporary canvas to composite the background
            const tempCanvas = document.createElement('canvas');
            tempCanvas.width = canvas.width;
            tempCanvas.height = canvas.height;
            const ctx = tempCanvas.getContext('2d');
            
            if (!ctx) return;

            // 1. Fill with the Scene Background Color (Little Grey)
            // Since the scene uses a transparent canvas to show the HTML background,
            // we must manually replicate that background color here.
            ctx.fillStyle = '#E5E7EB'; // Visibly "Little Grey" (Tailwind Gray-200)
            ctx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);

            // 2. Draw the 3D Canvas on top
            ctx.drawImage(canvas, 0, 0);

            // 3. Copy the composite
            tempCanvas.toBlob(async (blob) => {
                if (!blob) return;
                await navigator.clipboard.write([
                    new ClipboardItem({ 'image/png': blob })
                ]);
                setCopiedImage(true);
                setTimeout(() => setCopiedImage(false), 2000);
            }, 'image/png');
        } catch (error) {
            console.error('Failed to copy image:', error);
            alert('Failed to copy image. Try downloading instead.');
        }
    };

    // Download image
    const handleDownload = () => {
        try {
            const canvas = document.querySelector('canvas');
            if (!canvas) return;
            
            // Create a temporary canvas to composite the background
            const tempCanvas = document.createElement('canvas');
            tempCanvas.width = canvas.width;
            tempCanvas.height = canvas.height;
            const ctx = tempCanvas.getContext('2d');
            
            if (!ctx) return;

            // 1. Fill with the Scene Background Color (Little Grey)
            ctx.fillStyle = '#E5E7EB'; // Visibly "Little Grey" (Tailwind Gray-200)
            ctx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);

            // 2. Draw the 3D Canvas on top
            ctx.drawImage(canvas, 0, 0);

            // 3. Trigger Download
            const link = document.createElement('a');
            link.download = `mockup-${Date.now()}.png`;
            link.href = tempCanvas.toDataURL('image/png');
            link.click();
            
            onClose();
        } catch (error) {
            console.error('Failed to download:', error);
        }
    };

    // Share to platform (opens in new tab)
    const handleShare = (platformId: string) => {
        const url = encodeURIComponent(window.location.href);
        const text = encodeURIComponent('Check out my custom mockup!');
        
        let shareUrl = '';
        switch (platformId) {
            case 'facebook':
                shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
                break;
            case 'twitter':
                shareUrl = `https://twitter.com/intent/tweet?url=${url}&text=${text}`;
                break;
            case 'pinterest':
                shareUrl = `https://pinterest.com/pin/create/button/?url=${url}&description=${text}`;
                break;
            case 'linkedin':
                shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
                break;
            case 'whatsapp':
                shareUrl = `https://wa.me/?text=${text}%20${url}`;
                break;
            case 'email':
                shareUrl = `mailto:?subject=${text}&body=${url}`;
                break;
        }
        
        if (shareUrl) {
            window.open(shareUrl, '_blank', 'width=600,height=400');
        }
    };

    return (
        <>
            <div className="share-modal-backdrop" onClick={onClose} />
            <div className="share-modal-popup">
                <div className="share-modal-header">
                    <span>Share Design</span>
                    <button onClick={onClose}>×</button>
                </div>
                
                <div className="share-modal-content">
                    {/* Social Media Grid */}
                    <div className="share-platforms-grid">
                        {SOCIAL_PLATFORMS.map((platform) => (
                            <button
                                key={platform.id}
                                className="share-platform-btn"
                                onClick={() => handleShare(platform.id)}
                                title={platform.label}
                            >
                                <span className="share-platform-icon" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor" style={{color: platform.color}}>
                                        <path d={platform.path} />
                                    </svg>
                                </span>
                                <span className="share-platform-label">{platform.label}</span>
                            </button>
                        ))}
                    </div>
                    
                    {/* Quick Actions */}
                    <div className="share-actions">
                        <button 
                            className="share-action-btn"
                            onClick={handleCopyLink}
                        >
                            {copied ? <Check size={16} /> : <Copy size={16} />}
                            <span>{copied ? 'Copied!' : 'Copy Link'}</span>
                        </button>
                        
                        <button 
                            className="share-action-btn"
                            onClick={handleCopyImage}
                        >
                            {copiedImage ? <Check size={16} /> : <Copy size={16} />}
                            <span>{copiedImage ? 'Copied!' : 'Copy Image'}</span>
                        </button>
                        
                        <button 
                            className="share-action-btn primary"
                            onClick={handleDownload}
                        >
                            <Download size={16} />
                            <span>Download PNG</span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}
